<template>
  <div>
    <div style="margin-bottom: 10px;">
      <div
        v-if="model || googleInfo.agent_id"
        class="arrow mt-2 pa-2"
        style="border: 1px solid rgb(238, 238, 238);border-radius: 5px;"
      >
        <template v-if="googleInfo.agent_id">
          <v-layout wrap class="mb-3">
            <v-flex xs12>
              <div class="text-xs-left">
                <v-avatar class="mr-2">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    :src="data.logo_url ? data.logo_url : '/static/img/assets/livechat/profile.png'"
                  />
                </v-avatar>
                <span
                  >{{ googleInfo.agent_name }}
                  <template v-if="googleInfo.short_id">({{ googleInfo.short_id }})</template></span
                >
              </div>
            </v-flex>
            <template v-if="showDetail">
              <v-flex xs12 class="mt-3">
                <div class="form-control pa-1" v-if="googleInfo.brand_name">
                  <span
                    >{{ $t('Brand name') }}:
                    <template>{{ googleInfo.brand_name }}</template>
                  </span>
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="form-control pa-1" v-if="data.website_url">
                  <span
                    >{{ $t('Website') }}:
                    <template>{{ data.website_url }}</template>
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <div class="form-control pa-1" v-if="data.phone_number">
                  <span
                    >{{ $t('Phone Number') }}:
                    <template>{{ data.phone_number }}</template>
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-3">
                <div>
                  <span class="primary--text pa-1">Agent ID :</span> {{ googleInfo.agent_id }}
                </div>
                <div class="mt-2" style="overflow-wrap: break-word;">
                  <span class="primary--text pa-1">Test URL (For Mobile) :</span>
                  <a style="color: #1976d2;" :href="googleInfo.agent_test_url" target="blank">{{
                    googleInfo.agent_test_url
                  }}</a>
                </div>
                <div class="mt-2" style="overflow-wrap: break-word;">
                  <span class="primary--text pa-1">Test URL (For PC) :</span>
                  <a style="color: #1976d2;" :href="urlGoogleTestForPc" target="blank">{{
                    urlGoogleTestForPc
                  }}</a>
                </div>
              </v-flex>
              <small style="color:red">
                {{ $t('disconnect_google_contact_admin') }}
              </small>
            </template>
          </v-layout>
        </template>
        <template v-else>
          <div class="text-xs-center mb-2">
            <h4>{{ $t('google_connect_info') }}</h4>
          </div>
          <form>
            <v-layout wrap class="mb-3">
              <v-flex xs12>
                <div
                  v-if="data.logo_url && googleInfo.agent_id"
                  style="width: 180px; margin: auto;"
                >
                  <v-img :src="data.logo_url" :aspect-ratio="1" color="grey"></v-img>
                </div>
                <div
                  v-else
                  style="width: 40%;margin: auto; border-radius: 10px"
                  class="text-xs-center mt-3"
                >
                  <uploadfile
                    ref="answer"
                    v-model="data.logo_url"
                    :height="181"
                    data-vv-as="Image"
                    :data-vv-name="'answer_' + '_image_'"
                    v-validate
                    :backGroundAuto="true"
                  ></uploadfile>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="form-control pa-1" :class="{ 'has-error': errors.has('brandName') }">
                  <label>{{ $t('Brand name') }}*</label>
                  <input
                    :data-vv-as="$t('Brand name')"
                    v-validate="'required'"
                    v-model="data.brandName"
                    :disabled="googleInfo.agent_id"
                    name="brandName"
                    class="form-control"
                    type="text"
                    maxlength="50"
                  />
                  <span class="text-error" v-if="errors.has('brandName')">{{
                    errors.first('brandName')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="form-control pa-1" :class="{ 'has-error': errors.has('agentName') }">
                  <label>{{ $t('Agent name') }}*</label>
                  <input
                    :data-vv-as="$t('Agent name')"
                    v-validate="'required'"
                    v-model="data.agentName"
                    :disabled="googleInfo.agent_id"
                    name="agentName"
                    class="form-control"
                    type="text"
                    maxlength="50"
                  />
                  <span class="text-error" v-if="errors.has('agentName')">{{
                    errors.first('agentName')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="form-control pa-1" :class="{ 'has-error': errors.has('website') }">
                  <label>{{ $t('Website') }}*</label>
                  <input
                    :data-vv-as="$t('Website')"
                    v-validate="'required'"
                    v-model="data.website_url"
                    :disabled="googleInfo.agent_id"
                    name="website"
                    class="form-control"
                    type="text"
                    maxlength="50"
                  />
                  <span class="text-error" v-if="errors.has('website')">{{
                    errors.first('website')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="form-control pa-1" :class="{ 'has-error': errors.has('phoneNumber') }">
                  <label>{{ $t('Phone Number') }}*</label>
                  <input
                    :data-vv-as="$t('Phone Number')"
                    v-model="data.phone_number"
                    :disabled="googleInfo.agent_id"
                    name="phoneNumber"
                    class="form-control"
                    type="text"
                    minlength="11"
                    maxlength="12"
                    v-validate="{
                      required: true,
                      regex: /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{8}$/
                    }"
                  />
                  <span class="text-error" v-if="errors.has('phoneNumber')"
                    >{{ errors.first('phoneNumber') }} {{ $t('eg') }} +66909999999</span
                  >
                </div>
              </v-flex>
            </v-layout>

            <div class="text-xs-left">
              <small style="color:red">
                {{$t('check_information_cant_edit')}}
              </small>
            </div>
            <div class="text-xs-center">
              <v-btn color="grey" outline @click="$emit('input', false)" :loading="loading">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn color="primary" @click="confirmCreate" depressed :loading="loading">
                {{ $t('Connect') }}
              </v-btn>
            </div>
          </form>
        </template>

        <div class="text-xs-center" style="margin: 5px -13px -25px;" v-if="googleInfo.agent_id">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="toggleShowDetail"
            style="position:relative"
          >
            <i class="fa" :class="{ 'fa-angle-down': !showDetail, 'fa-angle-up': showDetail }"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value'],
  components: {
    uploadfile
  },
  data() {
    return {
      model: this.value,
      showDetail: false,
      loading: false,
      data: { brandName: '', agentName: '', logo_url: null, website_url: null, phone_number: null },
      googleInfo: {
        brand_name: null,
        agent_name: null,
        agent_id: null,
        agent_test_url: null,
        short_id: null
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    urlGoogleTestForPc() {
      const vm = this
      let agent_id = vm.googleInfo.agent_id ? vm.googleInfo.agent_id.split('agents/') : []
      if (agent_id.length > 0) {
        return `https://businessmessages.google.com/ad-link/v1/agent/${agent_id[1]}?agent_name=${vm.googleInfo.agent_name}`
      } else {
        return ''
      }
    }
  },
  mounted() {
    const vm = this
    vm.getGoogleApi()
  },
  methods: {
    toggleShowDetail() {
      this.showDetail = !this.showDetail
    },
    async getGoogleApi() {
      const vm = this
      let google_agent_config_json = null
      let logo_url = null
      let website_url = null
      let phone_number = null
      if (vm.selectedBot.google_agent_config_json) {
        try {
          google_agent_config_json = JSON.parse(vm.selectedBot.google_agent_config_json)
          logo_url = google_agent_config_json.businessMessagesAgent.logoUrl
          website_url =
            google_agent_config_json.businessMessagesAgent.nonLocalConfig.contactOption.url
          phone_number =
            google_agent_config_json.businessMessagesAgent.nonLocalConfig.phoneNumber.number
        } catch (error) {
          console.log(error)
        }
      }
      if (vm.selectedBot.google_agent_id) {
        vm.googleInfo = {
          brand_name: vm.selectedBot.google_brand_name,
          agent_name: vm.selectedBot.google_agent_name,
          agent_id: vm.selectedBot.google_agent_id,
          agent_test_url: vm.selectedBot.google_agent_test_url
        }
        const get_agent_id = vm.googleInfo.agent_id.split('/')
        vm.googleInfo.short_id = get_agent_id[3]
        vm.data = {
          brandName: vm.selectedBot.google_brand_name,
          agentName: vm.selectedBot.google_agent_name,
          logo_url: logo_url,
          website_url: website_url,
          phone_number: phone_number
        }
      }
    },
    async connectGoogleApi() {
      let vm = this

      try {
        let result = await vm.$validator.validateAll()
        if (result) {
          vm.loading = true
          const response = await vm.post(`google-business/${vm.selectedBot.pageid}/create-agent`, {
            brand_name: vm.data.brandName,
            agent_name: vm.data.agentName,
            logo_url: vm.data.logo_url,
            website_url: vm.data.website_url,
            phone_number: vm.data.phone_number
          })

          if (response.success) {
            vm.googleInfo = response.result
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: vm.$t(''),
              type: 'success'
            })
            vm.model = true
            vm.$emit('input', true)
            window.location.reload()
          }
          vm.loading = false
        }
      } catch (err) {
        console.log(err)
      }
    },
    confirmCreate() {
      this.$swal({
        title: this.$t('confirm_google_account'),
        html: ` <small style="color:red">
                * กรุณาใส่รายละเอียดให้ถูกต้อง หากเชื่อมต่อแล้วจะไม่สามารถแก้ไขได้
              </small>`,
        type: 'warning',
        cancelButtonText: this.$t('cancel'),
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.connectGoogleApi()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}
.btn-advanced:not(:hover) {
  background: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/SettingGoogle.vue